import FlexContainer from '../../common/flex-container';
import {SendTitle} from '../../formatted-messages';
import OutlinedInput from '../../common/outlined-input';
import React, {useContext, useState} from 'react';
import type WidgetProps from '../types/widget-props.ts';
import round from 'lodash.round';
import Button from '@mui/material/Button';
import SettingsIcon from '@mui/icons-material/Settings';
import styles from '../styles.module.css';
import cn from 'classnames';
import {SwapWidgetSelect} from '@/components/swap-widget-new/swap-widget-select';
import {SwapWidgetContext} from '@/pages/swap-widget';
import type {SwapWidgetContextProps} from '@/pages/swap-widget/types/swap-widget-context-props.ts';
import {styledMod} from '@/utils/styled-mod.tsx';

type SendWidgetProps = WidgetProps & {
  isVisibleSlippageSettingDialog: boolean;
  onVisibleSlippageSettingDialogChange: (isVisible: boolean) => void;
};

export const WidgetActiveTokenNameContainer = styledMod('label', styles['widget-active-token-name-container'])
export const WidgetActiveTokenNameImg = styledMod('img', styles['widget-active-token-name-img']);

const SendWidget: React.FunctionComponent<SendWidgetProps> = (props: SendWidgetProps) => {
  const [isVisibleTokensList, setVisibleTokensList] = useState<boolean>(false);

  const swapWidgetContext = useContext<SwapWidgetContextProps>(SwapWidgetContext);

  const onAmountValueChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const element = evt.target;
    const normalizedValue = element?.value.replace(',', '.');
    if (!/^\d*\.?\d*$/.test(normalizedValue)) {
      return;
    }
    props.onAmountValueChange(normalizedValue);
  };

  const onAmountInputFocus = (evt: React.FocusEvent<HTMLInputElement>) => {
    const element = evt.target;
    element.select();
  }

  const onVisibleSlippageSettingDialogChange = () => {
    props.onVisibleSlippageSettingDialogChange(!props.isVisibleSlippageSettingDialog);
  };

  const onTokenListOpen = () => {
    setVisibleTokensList(true);
  }

  const onTokenListClose = () => {
    setVisibleTokensList(false);
  }


  return (
    <div className={styles['widget-item-send-container']}>
      <FlexContainer
        alignitems="center"
        gap={10}
        height={36}
        alignself="flex-end"
        outline="1px solid var(--main-font-color)"
        borderradius="4px"
        margin="5px 3px 0 0"
        padding="0 5px"
      >
        <FlexContainer fontWeight={900} color="var(--primary-main-color)">
          {swapWidgetContext.slippageValue} %
        </FlexContainer>
        slippage
        <Button type="button" variant="text" onClick={onVisibleSlippageSettingDialogChange}>
          <SettingsIcon/>
        </Button>
      </FlexContainer>
      <div
        id="swap-send-widgets-container"
        className={cn(styles['widget-item-container'], styles['widget-item-token-container--send'])}
      >
        {isVisibleTokensList && (
          <SwapWidgetSelect
            onTokenAddressChange={props.onTokenAddressChange}
            tokensMetadata={props.tokensMetadata}
            onTokenListClose={onTokenListClose}
            rectParameters={props.rectParameters}
            onTokenAddressFavoritesChange={props.onTokenAddressFavoritesChange}
            type="send"
          />
        )}
        <FlexContainer className={styles['widget-amount-value-container']}>
          <FlexContainer alignitems="center" gap={10} height={36} margin="5px 0 0 0">
            <SendTitle/>
          </FlexContainer>
          <OutlinedInput
            value={swapWidgetContext.sendAmountValue !== null ? swapWidgetContext.sendAmountValue : null}
            onChange={onAmountValueChange}
            onFocus={onAmountInputFocus}
            type="text"
            inputProps={{inputMode: 'decimal', textAlign: 'center'}}
            isfullwidth={true}
            error={swapWidgetContext.isSendAmountTmp}
          />
          ${round(swapWidgetContext.sendUsdAmount ?? 0, 2)}
        </FlexContainer>
        <FlexContainer className={styles['widget-item-token-container']} margin="22px 0 0 0">
          <WidgetActiveTokenNameContainer onClick={onTokenListOpen}>
            {swapWidgetContext.sendTokenImageSrc && swapWidgetContext.sendTokenName && <>
                <WidgetActiveTokenNameImg src={swapWidgetContext.sendTokenImageSrc}
                                          alt={swapWidgetContext.sendTokenName}/>
              {swapWidgetContext.sendTokenName}
            </>}
          </WidgetActiveTokenNameContainer>
        </FlexContainer>
      </div>
    </div>
  );
};

export default SendWidget;
